import request from "@/utils/request";

export default {
  queryPage: (param) => {
    return request({
      url: `/qspiFspi/queryPage`,
      method: "post",
      data: param,
    });
  },
  getDetail: (scoreStage) => {
    return request({
      url: `/qspiFspi/getDetail/${scoreStage}`,
      method: "post",
    });
  },
  saveDetail: (param) => {
    return request({
      url: `/qspiFspi/saveDetail`,
      method: "post",
      data: param,
    });
  },
  submitDetail: (param) => {
    return request({
      url: `/qspiFspi/submit`,
      method: "post",
      data: param,
    });
  },
  queryHistory: (param) => {
    return request({
      url: `/qspiFspi/queryHistory`,
      method: "post",
      data: param,
    });
  },
  exportQspiFspi: (param) => {
    return request({
      url: `/qspiFspi/exportQspiFspi`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
};
